import { searchPaymentActive } from "../utils/searchPayment";
import RequestService from "./RequestService";
import {
  PaymentDefaultCardPayload,
  PaymentMethodPayload,
  PaymentsMethodsResponse,
  PaymentsMethodsResponseWithData,
} from "./typings/paymentsTypings";

class PaymentService {
  public static async getUserPaymentMethods(
    login: string
  ): Promise<any[] | undefined | Error> {
    const response = await RequestService.post<
      PaymentsMethodsResponseWithData | Error
    >("/users/get_payment_cards", { login });
    return response instanceof Error
      ? new Error("Error de Obtener medios de pago")
      : response.result.data;
  }

  public static async updateDefaultPayment(
    card: PaymentDefaultCardPayload
  ): Promise<string | undefined | Error> {
    const response = await RequestService.post<PaymentsMethodsResponse | Error>(
      "/users/payment_cards_patch",
      { ...card }
    );
    return response instanceof Error
      ? new Error("Error de Obtener medios de pago")
      : response.result.message;
  }

  public static async createPaymentCard(
    card: PaymentMethodPayload
  ): Promise<any | Error> {
    const response = await RequestService.post<any | Error>(
      "/users/payment_cards",
      { ...card }
    );
    return response instanceof Error
      ? new Error("Error de Verificación")
      : response;
  }

  public static async getDefaultPaymentMethod(
    login: string
  ): Promise<string | undefined> {
    let defaultPaymentMethod;
    const data = await PaymentService.getUserPaymentMethods(login);
    if (!(data instanceof Error) && data) {
      defaultPaymentMethod = searchPaymentActive(data);
    }
    return defaultPaymentMethod;
  }

  public static async deletePaymentMethod(
    login: string,
    id: string
  ): Promise<any | Error> {
    const response = await RequestService.post<any | Error>(
      "/users/payment_cards_delete",
      { login, id },
      true
    );
    return response;
  }

  public static async confirmPayment(
    userId: string,
    cardId: string
  ): Promise<any | Error> {
    const response = await RequestService.post<any | Error>(
      "/sale_order_confirm",
      {
        userId,
        paymentAcquirer: "prisma",
        cardId,
      },
      false
    );
    return response;
  }
}

export default PaymentService;
